import React from 'react';
import { isClientSide } from '../../../common/utils';

const DefaultFallback = () => {
  return <div data-hook="lazy-loader"></div>;
};

export const LazyLoader = ({
  lazyComponent: LazyComponent,
  fallback = <DefaultFallback />,
  ...props
}) => {
  return (
    <>
      {isClientSide() ? (
        <React.Suspense fallback={fallback}>
          <LazyComponent {...props} />
        </React.Suspense>
      ) : (
        <LazyComponent {...props} />
      )}
    </>
  );
};
